export enum GameStatus {
  NOT_CONNECTED = 'Not connected',
  MATCHMAKING = 'Matchmaking',
  WRONG_GAME_ID = 'Wrong game id',
  LOBBY = 'Lobby',
  LOBBY_SETTINGS = 'Lobby Settings',
  SENTENCE = 'Waiting for sentence',
  MATCH = 'Matching',
  VOTE = 'Voting',
  TURN_RESULTS = 'Turn results',
  GAME_SENTENCE_VOTE = 'Game sentence vote',
  GAME_END = 'Game results',
}